import { HospitalizationDto } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum HospitalizationEventTypes {
  HOSPITALIZATION_UPDATED = '[Hospitalization] Hospitalization Updated',
}

/**
 * Payloads
 */
export interface HospitalizationWSPayload {
  hospitalization: HospitalizationDto;
}

/**
 * Events
 */
export class HospitalizationWSMessage {
  type: string;
  constructor(public payload: HospitalizationWSPayload) {
    this.type = HospitalizationEventTypes.HOSPITALIZATION_UPDATED;
  }
}
